import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CloseIcon from '@mui/icons-material/Close'
import LinearProgress from '@mui/material/LinearProgress'
import Stack from '@mui/material/Stack'
import { IconButton, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import PriaSideIconSvg from './assets/pria-side-icon.svg'
import PrimaryButton from '../Buttons/PrimaryButton'
import SecondaryButton from '../Buttons/SecondaryButton'

export const PriaTourStep = ({
  title = '',
  description = '',
  submenuIntro = '',
  index = 1,
  total = 1,
  isLastStep = false,
  onNext = () => {},
  onBack = () => {},
  onSkip = () => {},
  onClose = null,
  showBack = false,
  showSkip = false,
  showProgress = true,
  actionButtonLabel = '',
}) => {
  const { t } = useTranslation()
  const nextLabel = actionButtonLabel || (isLastStep ? t('label.tour.initial.finish') : t('label.tour.initial.next'))

  return (
    <Stack spacing={2} sx={{ minWidth: 320, maxWidth: 400 }}>
      <Stack direction='row' spacing={2} alignItems='flex-start'>
        <img src={PriaSideIconSvg} alt='Pria Icon' style={{ marginTop: 4, flexShrink: 0 }} />
        <Stack spacing={0.5} flex={1}>
          <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
            <Typography variant='h6'>{title}</Typography>
            {onClose && (
              <IconButton size='small' onClick={onClose} sx={{ ml: 1, mt: -0.5, color: 'text.secondary' }}>
                <CloseIcon fontSize='small' />
              </IconButton>
            )}
          </Stack>
          <Typography variant='body2'>{description}</Typography>
          {submenuIntro && (
            <Typography variant='body2' sx={{ mt: 0.5, fontStyle: 'italic', opacity: 0.85 }}>
              {submenuIntro}
            </Typography>
          )}
        </Stack>
      </Stack>

      {showProgress && (
        <Stack direction='row' alignItems='center' spacing={2}>
          <Typography variant='caption' sx={{ whiteSpace: 'nowrap' }}>
            {index} / {total}
          </Typography>
          <LinearProgress
            variant='determinate'
            color='primary'
            value={(100 / total) * index}
            sx={{ height: 8, borderRadius: 4, flex: 1, '& .MuiLinearProgress-bar': { backgroundColor: 'var(--blue-color-5)' }, backgroundColor: 'var(--blue-color-1)' }}
          />
        </Stack>
      )}

      <Stack direction='row' spacing={1} alignItems='center'>
        {showBack && (
          <IconButton size='small' onClick={onBack} sx={{ color: 'var(--blue-color-5)' }}>
            <ArrowBackIcon fontSize='small' />
          </IconButton>
        )}
        {showSkip && !isLastStep && (
          <SecondaryButton
            marginTop='0'
            onClick={onSkip}
            label={t('label.tour.initial.skip.module')}
            width='100%'
            height='36px'
          />
        )}
        <PrimaryButton
          onClick={onNext}
          label={nextLabel}
          width='100%'
          height='36px'
        />
      </Stack>
    </Stack>
  )
}
